import React, { useEffect } from "react"
import gsap from "gsap"
import { motion } from "framer-motion"

const CustomCursor = () => {

  useEffect(() => {
    const timer = setTimeout(() => {
      const custom__s = document.querySelector('.custom__mouse__s')
      const custom__m = document.querySelector('.custom__mouse__m')

      
      function onMouseMove(e) {
        gsap.set([custom__s, custom__m], { xPercent: -50, yPercent: -50 })
        
        const tgt = e.target;
        const computed = window.getComputedStyle(tgt)["cursor"]

        if (computed !== 'auto') {
          //console.log("Computed: ", computed)
          gsap.to(custom__s, { duration: 0.5, ease: 'power3.out', scale: 8 })
          gsap.to(custom__m, { duration: 0.2, ease: 'power3.out', scale: 1.3 })
        } else {
          //console.log("Auto: ", computed)
          gsap.to(custom__s, { duration: 0.3, ease: 'power3.out', scale: 1 })
          gsap.to(custom__m, { duration: 0.3, ease: 'power3.out', scale: 1 })
        }
        gsap.to(custom__s, { duration: 0.4, ease: 'power3.out', left: e.clientX, top: e.clientY })
        gsap.to(custom__m, { duration: 0.4, ease: 'power3.out', left: e.clientX, top: e.clientY, delay: 0.055 })

      }
      document.addEventListener('mousemove', onMouseMove, false)

    }, 500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 1 } }} className="custom__mouse__group">
      <div className="custom__mouse__s" />
      <div className="custom__mouse__m" />
    </motion.div>
  )
}

export default CustomCursor